import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useAccount } from 'wagmi';
import folderIcon from '../../../assets/icons/folder.png';
import { useBreakpointContext } from '../../../context-providers/BreakpointProvider';

import { depositWithdrawalStore } from "../../../services/deposit-withdrawal/deposit-withdrawal.store";
import { positionsStore } from '../../../services/position/position.store';
import EmptyStateComponent from '../../EmptyState/EmptyState';
import { getActivityColumns } from '../helpers/activity-columns';
import { getDataGridCommonProps } from '../helpers/data-grid-common-props';
import WithdrawalSmallTableRow from '../small-table-rows/WithdrawalSmallTableRow';

const PAGE_SIZE = 100;
const emptyStateText = 'No withdrawals';

const UserWithdrawals = observer(() => {
    const { address } = useAccount();
    const withdrawColumns = getActivityColumns({ activityType: 'withdraw' });
    const { xs } = useBreakpointContext();

    const [paginationEnabled, setPaginationEnabled] = React.useState(positionsStore.openPositionsList.length > PAGE_SIZE);

    useEffect(() => {
        setPaginationEnabled(depositWithdrawalStore.withdrawals.length > PAGE_SIZE);
    }, [depositWithdrawalStore.withdrawals.length]);

    useEffect(() => {
        if (address) {
            depositWithdrawalStore.fetchWithdrawals(address)
        } else {
            depositWithdrawalStore.resetState()
        }
    }, [address]);

    return (<div className="TradeTabsNavigation__gridWrapper">
        {xs && depositWithdrawalStore.withdrawals.length ? depositWithdrawalStore.withdrawals.map((withdrawal, index) => {
            return <WithdrawalSmallTableRow key={index} withdrawal={withdrawal}/>;
        }): null}

        {xs && !depositWithdrawalStore.withdrawals.length ?
            <div className="TradeTabsNavigation__xsEmpty card-container"><EmptyStateComponent text={emptyStateText} icon={<img src={folderIcon} alt={emptyStateText}/>} /></div> : null
        }

        {!xs &&
            <DataGrid
                rows={depositWithdrawalStore.withdrawals}
                {...getDataGridCommonProps(emptyStateText)}
                columns={withdrawColumns}
                hideFooter={!paginationEnabled}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: PAGE_SIZE }
                    },
                    sorting: {
                        sortModel: [{ field: 'date', sort: 'desc' }]
                    }
                }}
            />}
    </div>);
});

export default UserWithdrawals;
